export default __webpack_public_path__ + "assets/pdf/FT_ZProp.4da7e5ce.pdf";